import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

interface ReactQueryProviderProps {
  children: React.ReactNode
}

const defaultOptions = {
  queries: {
    // staleTime: Infinity,
    refetchOnWindowFocus: false
  }
}

const queryClient = new QueryClient({ defaultOptions })

export const ReactQueryProvider = ({ children }: ReactQueryProviderProps): JSX.Element => {

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      {children}
    </QueryClientProvider>
  )
}
